import SmoothScroll from 'smooth-scroll'

export default class NativeSmoothScroll {
    constructor() {
        this.init()
    }
    init() {
        this.scroll = new SmoothScroll('a[href*="#"]', this.scrollOptions())
    }

    scrollOptions() {
        const self = this

        return {
            offset: function () {
                return self.getHeaderHeight()
            },
        }
    }

    getHeaderHeight() {
        const headerHeight = document.querySelector('.header').clientHeight

        return headerHeight
    }

    animateScroll(anchor, toggle, options) {
        return this.scroll.animateScroll(anchor, toggle, options)
    }

    cancelScroll() {
        return this.scroll.cancelScroll()
    }

    destroy() {
        return this.scroll.destroy()
    }
}
